import { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import ProfileSetup from './pages/ProfileSetup';
import Browse from './pages/Browse';
import Chat from './pages/Chat';
import ProfileDetail from './pages/ProfileDetail';
import MyProfile from './pages/MyProfile';
import Favorites from './pages/Favorites';
import AuthCallback from './pages/AuthCallback';
import Views from './pages/Views';
import Muted from './pages/Muted';
import Blocked from './pages/Blocked';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import PublicProfile from './pages/PublicProfile';
import Notifications from './pages/Notifications';
import Admin from './pages/Admin';
import AgeModal from './components/AgeModal';
import { Toaster } from 'sonner';

function App() {
  const [showAgeModal, setShowAgeModal] = useState(false);

  useEffect(() => {
    const agreed = localStorage.getItem('fnl_age_agreed');
    if (!agreed) setShowAgeModal(true);
  }, []);

  const handleAgree = () => {
    localStorage.setItem('fnl_age_agreed', 'true');
    setShowAgeModal(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/u/:slug" element={<PublicProfile />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/profile/setup"
              element={
                <ProtectedRoute requireProfile={false}>
                  <ProfileSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/browse"
              element={<ProtectedRoute><Browse /></ProtectedRoute>}
            />
            <Route
              path="/chat"
              element={<ProtectedRoute><Chat /></ProtectedRoute>}
            />
            <Route
              path="/chat/:userId"
              element={<ProtectedRoute><Chat /></ProtectedRoute>}
            />
            <Route
              path="/profile/:userId"
              element={<ProtectedRoute><ProfileDetail /></ProtectedRoute>}
            />
            <Route
              path="/me"
              element={<ProtectedRoute><MyProfile /></ProtectedRoute>}
            />
            <Route
              path="/favorites"
              element={<ProtectedRoute><Favorites /></ProtectedRoute>}
            />
            <Route
              path="/views"
              element={<ProtectedRoute><Views /></ProtectedRoute>}
            />
            <Route
              path="/muted"
              element={<ProtectedRoute><Muted /></ProtectedRoute>}
            />
            <Route
              path="/blocked"
              element={<ProtectedRoute><Blocked /></ProtectedRoute>}
            />
            <Route
              path="/notifications"
              element={<ProtectedRoute><Notifications /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute><Admin /></ProtectedRoute>}
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      {showAgeModal && <AgeModal onAgree={handleAgree} />}
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
